@if (cookieConsentService.showDialog()) {
  <aside
    role="region"
    aria-label="Consentimento de cookies"
    class="fixed bottom-0 inset-x-0 z-70 bg-[#0B0F17]/95 backdrop-blur-md border-t border-white/10 p-4 sm:p-6 text-white shadow-2xl"
  >
    <div
      class="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4"
    >
      <p
        class="text-sm text-neutral-300 leading-relaxed text-center md:text-left"
      >
        Utilizamos cookies e tecnologias semelhantes para melhorar a sua
        experiência e personalizar conteúdo, em conformidade com a LGPD. Saiba
        mais em nossa
        <a
          routerLink="/politica-de-privacidade"
          class="text-primary underline hover:text-primary-focus transition-colors"
        >
          Política de Privacidade </a
        >.
      </p>

      <div
        class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto shrink-0"
      >
        <button
          type="button"
          class="btn btn-outline min-h-11 w-full sm:w-auto"
          data-testid="cookie-consent-essential-btn"
          (click)="cookieConsentService.acceptEssential()"
        >
          Apenas essenciais
        </button>
        <button
          type="button"
          class="btn btn-primary min-h-11 w-full sm:w-auto"
          data-testid="cookie-consent-all-btn"
          (click)="cookieConsentService.acceptAll()"
        >
          Aceitar todos
        </button>
      </div>
    </div>
  </aside>
}
